import React from 'react'

declare global {
    interface Window {
        getCkyConsent?: () => {
            activeLaw: string
        }
    }

    interface CookieYesBannerLoadDetail {
        activeLaw: 'gdpr' | 'ccpa'
        categories: {
            necessary: boolean
            functional: boolean
            analytics: boolean
            performance: boolean
            advertisement: boolean
        }
        isUserActionCompleted: boolean
        consentID: string
        languageCode: string
    }

    interface DocumentEventMap {
        cookieyes_banner_load: CustomEvent<CookieYesBannerLoadDetail>
    }
}

export const ActiveLawContext = React.createContext<string>('')

export function ActiveLawProvider({ children }: React.PropsWithChildren) {
    const activeLaw = React.useSyncExternalStore(
        (callback) => {
            document.addEventListener('cookieyes_banner_load', callback)

            return () => {
                document.removeEventListener('cookieyes_banner_load', callback)
            }
        },
        () => window.getCkyConsent?.().activeLaw ?? '',
        () => '' // Server snapshot
    )

    return <ActiveLawContext value={activeLaw}>{children}</ActiveLawContext>
}
